
import { useState } from "react";
import Viewer360 from "./components/Viewer360";
import "./App.css";

export default function App() {
  return (
    <Viewer360 />
  );
}